import Trans from 'next-translate/Trans'
import React from 'react'
import { GButton } from 'tennders-common/form/components'
import { withSocket } from 'tennders-transactions/hocs/withSocket'
import DOMPurify from 'dompurify'
import GLoading from 'tennders-market/common/components/element/GLoading'
import dynamic from 'next/dynamic'
import { dateToStr } from 'tennders-stracture/libs/utils'
import moment from 'moment'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const TruckHistory = (props) => {
  const { logs, loading, isSingleView, more, loadMore } = props

  const ellipsisOptions = {
    multiline: true,
    className: 'ellipsis-tooltip custom-color-tooltip'
  }

  return (
    loading
      ? <GLoading size={30} />
      : (
        <>
          {
            logs.map((log) => (
              isSingleView
                ? (
                  <div key={`truck${log.id}`} className="d-flex border-b b-2d">
                    <div className="w-30 table-padding">
                      {log.shortMessage}
                      {' '}
                      <br />
                      {moment(log.createdAt).utc().format('DD/MM/YYYY HH:mm')}
                    </div>
                    <div className="w-70 pt-10 pr-8">
                      <EllipsisToolTip options={ellipsisOptions}>
                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(log.message) }} />
                      </EllipsisToolTip>
                    </div>
                  </div>
                ) : (
                  <div key={`truck${log.id}`} className="border-b">
                    <div className="table-padding">
                      <div>
                        <EllipsisToolTip options={ellipsisOptions}>
                          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(log.message) }} />
                        </EllipsisToolTip>
                      </div>
                      <div className="text-11 mt-10 italic">
                        {moment(log.createdAt).utc().format('DD/MM/YYYY HH:mm')}
                        {' - '}
                        {log.shortMessage}
                      </div>
                    </div>
                  </div>
                )
            ))
          }
          {more && (
            <div className="text-center mt-10">
              <GButton className="btn-border medium standard-btn m-auto" onClick={loadMore}>
                <Trans i18nKey="transaction:loadMore" />
              </GButton>
            </div>
          )}
        </>
      )
  )
}
export default withSocket(TruckHistory)
